export default __webpack_public_path__ + "images/VG.13bca29.png";